import { css } from "@emotion/css";

const historyBetStyles = {
	wrap: css`
		background: linear-gradient(180deg, rgba(17, 28, 50, 1) 0%, rgba(21, 29, 50, 1) 57%, rgba(0, 0, 0, 1) 100%);
		color: #fff;
		border: 1px solid #fbae3d;
		border-radius: 8px;
		padding: 4px;
		position: relative;
		min-height: 390px;
		.title {
			text-align: center;
			font-size: 18px;
			padding: 8px 0 16px;
		}
		table {
			width: 100%;
			border-spacing: 0;
		}
		.table-header {
			background: linear-gradient(180deg, rgba(105, 16, 232, 1) 0%, rgba(55, 4, 97, 1) 100%);

			th {
				padding: 6px 0;
				&:first-child {
					border-top-left-radius: 4px;
					border-bottom-left-radius: 4px;
				}
				&:last-child {
					border-top-right-radius: 4px;
					border-bottom-right-radius: 4px;
				}
			}
		}
		tbody {
			min-height: 306px;
		}
		.table-row {
			td {
				padding: 8px;
				text-align: center;
				border-bottom: 1px solid #29395e;
				font-size: 14px;
				&.placedBet {
					span {
						color: #fbae3d;
					}
				}
				.moneyAdjustment {
					position: relative;
					&::before {
						content: "";
						position: absolute;
						top: 50%;
						left: 50%;
						width: 120%;
						height: 2px;
						background: #fff;
						margin-top: -1px;
						transform: translateX(-50%);
					}
				}
			}
		}
		.history-footer {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 40px;
			.game-option {
				display: flex;
				align-items: center;
				gap: 8px;
				select {
					background: #000;
					color: #fff;
					padding: 4px 8px;
					border-radius: 8px;
					border: 1px solid #fff9d7;
				}
			}
			.pagination {
				padding: 4px 0;
			}
			&.mobile {
				padding: 0 8px;

				.game-option {
					select {
						font-size: 14px;
					}
				}
				.pagination {
					input {
						width: 60px;
					}
				}
			}
		}
	`,
	wrapTable: css`
		height: 500px;
		overflow-y: auto;
		&.mobile-view {
			height: 400px;
		}
	`,
	btnClose: css`
		position: absolute;
		top: 8px;
		right: 8px;
		cursor: pointer;
		img {
			width: 24px;
		}
	`,
	pagination: css`
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		padding: 12px 0;
		input {
			width: 100px;
			background: none;
			border: 1px solid #fff9d7;
			border-radius: 8px;
			padding: 4px 8px;
			text-align: center;
			color: #fff;

			&::-webkit-outer-spin-button,
			&::-webkit-inner-spin-button {
				-webkit-appearance: none;
				margin: 0;
			}
		}
		button {
			display: flex;
			width: 30px;
			height: 30px;
			&:active {
				transform: scale(0.95);
			}
			&:disabled {
				opacity: 0.7;
				pointer-events: none;
			}
			img {
				width: 100%;
			}
		}
	`,
};
export default historyBetStyles;
